import HttpClient from '@/utils/HttpClient';
import ProjectStore from '@/store/Projects';

export default {
  setActiveProjectId(id) {
    return HttpClient.postAuthenticated(`/api/me/activeProject`, { projectId: id });
  },
  getUserInfo() {
    return HttpClient.getAuthenticated(`/api/me`);
  },
  getUserPicture() {
    return HttpClient.getAuthenticated(`/api/me/picture`);
  },
  setUserPicture(picture) {
    return HttpClient.postAuthenticated(`/api/me/picture`, { picture });
  },
  getCustomThemeByProject(projectId) {
    return HttpClient.getAuthenticated(`/api/projects/${projectId}/customtheme`);
  },
  sendPwResetMail() {
    return HttpClient.getAuthenticated(`/api/me/sendPwResetMail`);
  },
  leaveProject() {
    return HttpClient.postAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/leave`);
  },
  becomeCustomer() {
    return HttpClient.postAuthenticated(`/api/projects/${ProjectStore.activeProject.DbId}/engage`);
  }
};
